module.exports = __webpack_public_path__ + "img/qiandoa.c4e87f57.png";